module.exports = __webpack_public_path__ + "img/podium_1004.239acfc0.jpg";